module.exports = __webpack_public_path__ + "img/popconfirm.dbfc800d.svg";